export const root = "/";
export const login = "login";
export const register = "register";
